import {useEffect} from "react";

/**
 * Puts the page in front of the application's title ("Foto – eKultur DAMS"), and restores the previous title
 * when the page goes (DE-1719, WCAG 2.4.2: tabs opened from the publishing log can be told apart).
 * @param {?string} pageTitle - Nothing is changed while empty.
 */
export const usePageTitle = (pageTitle) => {
    useEffect(() => {
        if (!pageTitle) {
            return undefined;
        }
        const previous = document.title;
        document.title = `${pageTitle} – ${previous}`;
        return () => {
            document.title = previous;
        };
    }, [pageTitle]);
};
